import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { AiOutlinePlusSquare } from 'react-icons/ai';
import moment from 'moment';
import iconHubsales from '../assets/logo-hubsales.png';
import AccountMenu from '../components/menu-responsavel';
import { meusChamados, meuChamado, responderChamado, mensagemDe, anexosDoMeuChamado, baixarAnexoMeu } from '../services/motor';
import './styles.css'

/**
 * MEUS CHAMADOS (nível 1, 04/09/2026): o que ESTE e-mail abriu, lido do nosso
 * backoffice (`/publico/chamados/meus`). Até 04/09 esta página listava tickets
 * da API da Octadesk com o token do login antigo.
 *
 * O cliente vê a conversa pública e responde; a resposta vai ao MOTOR
 * (reabre se estava fechado e avisa o dono). Anotação interna e proposta do
 * agente nunca chegam aqui — o servidor já filtra.
 */
const ESTADO = {
    recebida: 'Recebido', aguardando_identificacao: 'Em triagem', analisada: 'Em análise',
    apta: 'Em análise', aprovada: 'Em análise', processando: 'Em andamento', em_execucao: 'Em andamento',
    aguardando_cliente: 'Aguardando você', processada: 'Em andamento', validada: 'Resolvido',
    cliente_notificado: 'Resolvido', falhou: 'Em andamento', replanejada: 'Em andamento'
};
const rotulo = (c) => c.fechada_em ? 'Resolvido' : (ESTADO[c.estado] || c.estado);
const quando = (d) => d ? moment(d).format('DD/MM/YYYY HH:mm') : '';

function Solicitacoes() {
    const navigate = useNavigate();
    const contato = sessionStorage.getItem("nome") || '';
    const [lista, setLista] = useState(null);
    const [erro, setErro] = useState('');
    const [aberto, setAberto] = useState(null);
    const [resposta, setResposta] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [avisoResposta, setAvisoResposta] = useState('');
    // 📎 16/09: os arquivos do chamado aberto (o que o cliente pode ver — o servidor filtra)
    const [anexos, setAnexos] = useState([]);
    const [params, setParams] = useSearchParams();

    useEffect(() => { document.title = "HubsAI | Meus chamados"; }, []);
    useEffect(() => {
        meusChamados().then(setLista).catch((e) => setErro(mensagemDe(e, 'Não consegui carregar os seus chamados.')));
    }, []);

    async function abrir(id) {
        setAvisoResposta(''); setResposta(''); setAnexos([]);
        try {
            setAberto(await meuChamado(id));
            // arquivo que não carrega não pode esconder a conversa: falha aqui só esvazia a lista
            anexosDoMeuChamado(id).then(setAnexos).catch(() => setAnexos([]));
        }
        catch (e) { setErro(mensagemDe(e, 'Não consegui abrir o chamado.')); }
    }

    // 🔗 16/09: o botão do e-mail chega como /solicitacoes?chamado=N — abre aquele
    // chamado e tira o parâmetro da URL (recarregar não reabre sozinho).
    useEffect(() => {
        const n = Number(params.get('chamado'));
        if (Number.isInteger(n) && n > 0) {
            abrir(n);
            const resto = new URLSearchParams(params); resto.delete('chamado');
            setParams(resto, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);
    async function responder(e) {
        e.preventDefault();
        if (!resposta.trim()) return;
        setEnviando(true);
        try {
            const r = await responderChamado(aberto.id, resposta.trim());
            setAvisoResposta(r && r.reaberto ? 'Enviado. O chamado foi reaberto para a equipe.' : 'Enviado para a equipe.');
            setResposta('');
            setAberto(await meuChamado(aberto.id));
            setLista(await meusChamados());
        } catch (err) {
            setAvisoResposta(mensagemDe(err, 'Não consegui enviar a resposta.'));
        } finally { setEnviando(false); }
    }

    return (
        <Fragment>
            <div className="navbar">
                <span className="navbar-form-title">
                    <img className="iconHub" src={iconHubsales} alt="HubsAI" />
                    <span className="title-portal"> Portal de Atendimento</span>
                </span>
                <div className="navbar2">
                    <Tooltip title="Abrir um chamado novo" arrow>
                        <Link to="/forms" className="container-button-forms"><i><AiOutlinePlusSquare /></i></Link>
                    </Tooltip>
                    <div className='container-button-logout'>
                        <AccountMenu organization={''} contato={contato} avatar={contato.substr(0, 1)} />
                    </div>
                </div>
            </div>

            <div style={{ maxWidth: 1100, margin: '24px auto', padding: '0 16px', display: 'grid', gridTemplateColumns: aberto ? '1fr 1.4fr' : '1fr', gap: 24 }}>
                <div>
                    <h2 style={{ marginTop: 0 }}>Meus chamados</h2>
                    {erro && <p style={{ color: '#b91c1c' }}>{erro}</p>}
                    {lista === null && !erro && <p>Carregando…</p>}
                    {lista && lista.length === 0 && <p>Você ainda não abriu nenhum chamado. <Link to="/forms">Abrir o primeiro</Link>.</p>}
                    {lista && lista.map((c) => (
                        <button key={c.id} type="button" onClick={() => abrir(c.id)}
                            style={{ display: 'block', width: '100%', textAlign: 'left', background: aberto && aberto.id === c.id ? '#ede9fe' : '#fff',
                                     border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 14px', marginBottom: 8, cursor: 'pointer' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                                <strong>#{c.id} · {c.assunto}</strong>
                                <span style={{ whiteSpace: 'nowrap', color: c.fechada_em ? '#15803d' : '#6d28d9' }}>{rotulo(c)}</span>
                            </div>
                            <div style={{ fontSize: 13, color: '#6b7280' }}>
                                {c.categoria ? `${c.categoria} · ${c.subcategoria} · ` : ''}aberto em {quando(c.aberta_em)}
                                {c.ultimo_lado === 'equipe' && !c.fechada_em ? ' · a equipe respondeu' : ''}
                            </div>
                        </button>
                    ))}
                </div>
                {aberto && (
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, background: '#fff' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                            <h3 style={{ margin: 0 }}>#{aberto.id} · {aberto.assunto}</h3>
                            <button type="button" onClick={() => setAberto(null)} style={{ border: 0, background: 'none', cursor: 'pointer', color: '#6b7280' }}>fechar</button>
                        </div>
                        <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 12 }}>
                            {rotulo(aberto)} · aberto em {quando(aberto.aberta_em)}{aberto.fechada_em ? ` · resolvido em ${quando(aberto.fechada_em)}` : ''}
                        </div>
                        <div style={{ maxHeight: 420, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {(aberto.conversa || []).map((m) => (
                                <div key={m.id} style={{ alignSelf: m.autor_lado === 'cliente' ? 'flex-end' : 'flex-start', maxWidth: '85%',
                                     background: m.autor_lado === 'cliente' ? '#ede9fe' : (m.autor_lado === 'sistema' ? '#f3f4f6' : '#f0fdf4'),
                                     borderRadius: 8, padding: '8px 12px', fontSize: m.autor_lado === 'sistema' ? 12 : 14 }}>
                                    <div style={{ fontSize: 11, color: '#6b7280' }}>
                                        {m.autor_lado === 'cliente' ? 'Você' : (m.autor_lado === 'equipe' ? (m.autor || 'Equipe HubsAI') : 'Sistema')} · {quando(m.criada_em)}
                                    </div>
                                    <div style={{ whiteSpace: 'pre-wrap' }}>{m.corpo}</div>
                                </div>
                            ))}
                        </div>
                        {anexos.length > 0 && (
                            <div style={{ marginTop: 12, borderTop: '1px solid #e5e7eb', paddingTop: 10 }}>
                                <div style={{ fontSize: 13, color: '#374151', marginBottom: 6 }}>
                                    📎 Arquivos deste chamado
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                    {anexos.map((a) => (
                                        <button key={a.id} type="button" title={a.origem === 'cliente' ? 'Enviado por você' : 'Enviado pela equipe HubsAI'}
                                            onClick={() => baixarAnexoMeu(a.id, a.nome).catch((err) => setAvisoResposta(mensagemDe(err, 'Não consegui baixar o arquivo.')))}
                                            style={{ border: '1px solid #d1d5db', borderRadius: 8, background: '#f9fafb', padding: '6px 10px', cursor: 'pointer', fontSize: 13 }}>
                                            ⬇ {a.nome}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                        <form onSubmit={responder} style={{ marginTop: 12 }}>
                            <textarea value={resposta} onChange={(e) => setResposta(e.target.value)} rows={3} maxLength={8000}
                                placeholder={aberto.fechada_em ? 'Responder reabre o chamado para a equipe.' : 'Escreva a sua resposta para a equipe.'}
                                style={{ width: '100%', boxSizing: 'border-box', borderRadius: 8, border: '1px solid #d1d5db', padding: 8 }} />
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                <span style={{ fontSize: 13, color: '#6d28d9' }}>{avisoResposta}</span>
                                <button disabled={enviando || !resposta.trim()} className="login-form-btn2" style={{ padding: '8px 18px', minWidth: 0 }}>{enviando ? 'Enviando…' : 'Enviar'}</button>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default Solicitacoes;
